// apps/web/src/components/consents/ConsentsManager.tsx
// Consent records management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Consent } from '../../types/platform.js';

export function ConsentsManager() {
  return (
    <ManagerPage
      title="Consents"
      listPath="/api/v1/consents"
      listKey="consents"
      createLabel="New Consent"
      className="consents-manager"
      renderItem={(raw) => {
        const c = raw as Consent;
        return (
          <div className="manager-card" key={c.id}>
            <h3>{c.name}</h3>
            <p className="status-badge">{c.status}</p>
            <p>{c.consentType}{c.required ? ' · Required' : ''}</p>
            <p>{c.expiresAt ? `Expires ${c.expiresAt}` : 'No expiry'}</p>
            <div className="actions">
              <button className="btn btn-secondary">History</button>
              <button className="btn btn-primary">Renew</button>
              <button className="btn btn-danger">Withdraw</button>
            </div>
          </div>
        );
      }}
    />
  );
}